/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';

export function fetchSettings() {
	return ({ dispatch }) => {
		dispatch({ type: 'FETCH_SETTINGS_PENDING' });

		apiFetch({
			path: "/wpxero/marqueex/v1/get_settings",
			method: "GET",
		})
			.then((res) => {
				dispatch({
					type: "FETCH_SETTINGS_SUCCESS",
					settings: res.response || {},
				});
			})
			.catch((err) => {
				dispatch({
					type: "FETCH_SETTINGS_ERROR",
					error:
						err?.response ||
						err?.error_code ||
						__("Failed to load settings", "marqueex"),
				});
			});
	};
}

export function updateSettings(settings) {
	return ({ dispatch }) => {
		if (!settings || !Object.keys(settings).length) {
			return;
		}

		dispatch({ type: 'UPDATE_SETTINGS_PENDING' });

		const data = { settings };

		apiFetch({
			path: "/wpxero/marqueex/v1/update_settings",
			method: "POST",
			data,
		})
			.then((res) => {
				dispatch({
					type: "UPDATE_SETTINGS_SUCCESS",
					settings: res.response?.settings || settings,
				});
				return res.response;
			})
			.catch((err) => {
				dispatch({
					type: "UPDATE_SETTINGS_ERROR",
					error:
						err?.response ||
						err?.error_code ||
						__("Something went wrong, please, try again…", "marqueex"),
				});
			});
	};
}

export function saveSettings() {
	return ({ dispatch, select }) => {
		const settings = select.getSettings();
		return dispatch.updateSettings(settings);
	};
}

export function testBuilderIntegration(builder) {
	return async ({ dispatch }) => {
		dispatch({ type: 'TEST_BUILDER_PENDING', builder });

		try {
			const response = await apiFetch({
				path: "/wpxero/marqueex/v1/test_builder",
				method: "POST",
				data: { builder },
			});

			const result = response.response || response;

			dispatch({
				type: "TEST_BUILDER_SUCCESS",
				builder,
				result,
			});

			return result;
		} catch (err) {
			const error = err?.response || err?.error_code || __("Failed to test integration", "marqueex");

			dispatch({
				type: "TEST_BUILDER_ERROR",
				builder,
				error,
			});

			throw new Error(error);
		}
	};
}
